/**
 * Extracts the mobile app version from a user agent string.
 * @param userAgent - The user agent string to parse, defaults to navigator.userAgent
 * @returns The mobile app version string, or empty string if not found
 */
function getMobileAppVersion(userAgent: string = navigator.userAgent): string {
  const regex = /com\.vio\.mobileapp\s+(\d+\.\d+\.\d+(-\w+)*)/
  const match = userAgent.match(regex)
  return match ? match[1] : ''
}

export {getMobileAppVersion}
